<template>
    <div>
        <h3>Vorvertragliche Anzeigepflicht</h3>
        <b>Beantworten Sie bitte die nachfolgenden Fragen nach bestem Wissen sorgfältig, vollständig und wahrheitsgemäß.</b>

        <br>
        <p style="color:#444;">
            Verletzen Sie Ihre vorvertragliche Anzeigepflicht, kann dies dem Versicherer zum Rücktritt,
            zur Kündigung oder zu einer Vertragsanpassung berechtigen. Im Schadenfall kann
            eine eventuelle Versicherungsleistung gekürzt oder verweigert werden.
            Eine rückwirkende Anpassung des Vertrages kann zum Verlust des Versicherungsschutzes führen.
            Ungeachtet dessen kann der Versicherer den Vertrag bei arglistiger Täuschung
            anfechten und eine eventuelle Versicherungsleistung verweigern.
            Bitte beachten Sie hierzu die Ausführungen zur Bedeutung der vorvertraglichen Anzeigepflicht gemäß § 19 Absatz 5 Versicherungsvertragsgesetz (VVG)
            unter <i>"Wichtige Hinweise zur vorvertraglichen Anzeigepflicht und zu Ihrem Versicherungsschutz"</i> auf Seite 4 des Antrages in ihrem späteren Email-Anhang.
        </p>
    </div>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>


    export default {
        //========================================================================================================
        data: function () {

            return {}
        }, //========================================================================================================
        name: 'Anzeigepflicht-Block',
        label: 'Anzeigepflicht-Block',
        //========================================================================================================
    }
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style>

</style>
